/** Formatting helpers. All formatters are null-safe and render em-dashes for missing data — never fabricated zeros. */

export function fmtUsd(v: number | null | undefined, digits = 2): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—'
  return v.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })
}

export function fmtNum(v: number | null | undefined, digits = 4): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—'
  return v.toLocaleString('en-US', { maximumFractionDigits: digits })
}

export function fmtPct(v: number | null | undefined, digits = 2): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—'
  return `${(v * 100).toFixed(digits)}%`
}

export function fmtSignedPct(
  v: number | null | undefined,
  digits = 2,
): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—'
  const s = (v * 100).toFixed(digits)
  return v > 0 ? `+${s}%` : `${s}%`
}

/** Accepts epoch-ms numbers (the gateway's timestamp format) or ISO strings. */
export function fmtTime(t: number | string | null | undefined): string {
  if (t === null || t === undefined || t === '') return '—'
  const d = new Date(t)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toISOString().replace('T', ' ').slice(0, 19) + 'Z'
}

/** Date part only (YYYY-MM-DD) from epoch ms — for chart axes/tooltips. */
export function fmtDate(t: number | string | null | undefined): string {
  const full = fmtTime(t)
  return full === '—' ? full : full.slice(0, 10)
}

export function shortAddr(addr: string | null | undefined): string {
  if (!addr) return '—'
  if (addr.length <= 12) return addr
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`
}

export function shortHash(hash: string | null | undefined): string {
  return shortAddr(hash)
}

export function signColor(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v) || v === 0)
    return 'text-crt-gray'
  return v > 0 ? 'text-crt-pos' : 'text-crt-neg'
}
